import wire from '../wire';
import template from './new-event.html';
import NewEventController from './new-event-controller';

var module = wire(
  'new-event',
  template,
  NewEventController,
  'NewEventController',
  '/new-event?cloneId&boxcasterId&streamSource&staticRtmpId&sourceBroadcastId'
);

// Require this *after* we create the module via `wire` above
require('./directives');

export default module;



// WEBPACK FOOTER //
// ./app/pages/new-event/_index.js